// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--qfFZW","switch":"styles-module--switch--fn5cQ"};